import gql from 'graphql-tag';

const createBusinessMessageMutation = () => gql`
  mutation createBusinessMessage($input: CreateBusinessMessageInput!) {
    createBusinessMessage(input: $input) {
      result {
        id
      }
      errors
      messages
    }
  }
`;

export default createBusinessMessageMutation;
